import { render } from "./Verificacao.vue?vue&type=template&id=54df961d"
import script from "./Verificacao.vue?vue&type=script&lang=js"
export * from "./Verificacao.vue?vue&type=script&lang=js"

import "./Verificacao.vue?vue&type=style&index=0&id=54df961d&lang=css"

import exportComponent from "/home/thales/Projetos/termos-telemidia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__